
var cjs = createjs;
var AdobeAn = {}
var an = AdobeAn;
var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [];

(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



// stage content:
(lib.iEVlogoanimation1a = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.actionFrames = [35, 94];
	// timeline functions:
	this.frame_94 = function() {
		var _this = this;
    an.endHandler(_this)
    // _this.stop();
	}
	this.frame_35 = function() {
		var _this = this;
    if(an.header == true)
      _this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(35).call(this.frame_35).wait(1));
	this.timeline.addTween(cjs.Tween.get(this).wait(94).call(this.frame_94).wait(1));

	// dot
	this.shape = new cjs.Shape();
	this.shape.graphics.f(an.fillColor).s().p("AgdDwIAAnfIA7AAIAAHfg");
	this.shape.setTransform(3,24);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f(an.fillColor).s().p("Ah8DwIAAnfID5AAIAAHfg");
	this.shape_1.setTransform(12.5,24);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f(an.fillColor).s().p("AjbDwIAAnfIG3AAIAAHfg");
	this.shape_2.setTransform(22,24);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f(an.fillColor).s().p("Ak6DwIAAnfIJ1AAIAAHfg");
	this.shape_3.setTransform(31.5,24);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f(an.fillColor).s().p("AmZDwIAAnfIMzAAIAAHfg");
	this.shape_4.setTransform(41,24);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f(an.fillColor).s().p("AmKDwIAAnfIMVAAIAAHfg");
	this.shape_5.setTransform(42.5,24);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f(an.fillColor).s().p("AldDwIAAnfIK7AAIAAHfg");
	this.shape_6.setTransform(47,24);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f(an.fillColor).s().p("AkSDwIAAnfIIlAAIAAHfg");
	this.shape_7.setTransform(54.5,24);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f(an.fillColor).s().p("AipDwIAAnfIFTAAIAAHfg");
	this.shape_8.setTransform(65,24);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f(an.fillColor).s().p("AgiDwIAAnfIBFAAIAAHfg");
	this.shape_9.setTransform(78.5,24);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape}]},1).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_4}]},1).to({state:[{t:this.shape_4}]},67).to({state:[{t:this.shape_5}]},1).to({state:[{t:this.shape_6}]},1).to({state:[{t:this.shape_7}]},1).to({state:[{t:this.shape_8}]},1).to({state:[{t:this.shape_9}]},1).to({state:[]},1).wait(17));

	// V_curve
	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f(an.fillColor).s().p("AgODsIAAnXIAdAAIAAHXg");
	this.shape_10.setTransform(301,23.6);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f(an.fillColor).s().p("AiADsIAAnXID7AAIAHHXg");
	this.shape_11.setTransform(312.45,23.6);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f(an.fillColor).s().p("AjvDsIAAnXIHfAAIAAHXg");
	this.shape_12.setTransform(323.5,23.6);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f(an.fillColor).s().p("AEEDrIprAAIAAnXIJrAAQAzABAxAEIhGHUIgegCg");
	this.shape_13.setTransform(335.525,23.65);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f(an.fillColor).s().p("ACJDhIprAAIAAnXIJrAAQC2AACkA2Ii2G3QhQgWhUAAg");
	this.shape_14.setTransform(347.775,24.7);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f(an.fillColor).s().p("AAOC9IprAAIAAnXIJrAAQFDAAENCsIkMGJQiYheisAAg");
	this.shape_15.setTransform(360.125,28.25);

	this.shape_16 = new cjs.Shape();
	this.shape_16.graphics.f(an.fillColor).s().p("AhfCCIpsAAIAAnXIJsAAQHMAAFfFbIlQFQQjYjUkDAAg");
	this.shape_16.setTransform(371.125,34.225);

	this.shape_17 = new cjs.Shape();
	this.shape_17.graphics.f(an.fillColor).s().p("AEUDrQjwkXkqAAIpsAAIAAnYIJsAAQH4AAF0GhQCGCUCHDgImcD0Qhui2hVhkg");
	this.shape_17.setTransform(387.85,51.7);

	this.shape_18 = new cjs.Shape();
	this.shape_18.graphics.f(an.fillColor).s().p("ACbAfQjvkXkrAAIpsAAIAAnYIJsAAQH4AAF1GhQCSCjCTD5QBQCICJEOImtDOQj/nyiljAg");
	this.shape_18.setTransform(399.9,72.1);

	this.shape_19 = new cjs.Shape();
	this.shape_19.graphics.f(an.fillColor).s().p("AHiIgQkSodiujKQjvkZkrAAIpsAAIAAnYIJsAAQH4AAF1GhQCSCkCTD5QBXCUCbEzQB5DtBgCkImmDbQhmivh3jqg");
	this.shape_19.setTransform(412,95.25);

	this.shape_20 = new cjs.Shape();
	this.shape_20.graphics.f(an.fillColor).s().p("AGfGcQkSoditjLQjwkYkrAAIpsAAIAAnYIJsAAQH5AAF0GhQCSCjCTD6QBXCVCbExQDWGlCJC8ImAEUQipjpjgm4g");
	this.shape_20.setTransform(418.675,108.475);

	this.shape_21 = new cjs.Shape();
	this.shape_21.graphics.f(an.fillColor).s().p("AM5Q6QjEjgkcowQkSocitjLQjwkZkrAAIpsAAIAAnYIJsAAQH5AAF0GhQCSCkCTD5QBXCVCbEyQDzHeCQCzQAyA+A2AwIlEFYQg7g1g2g/g");
	this.shape_21.setTransform(425.7,119.85);

	this.shape_22 = new cjs.Shape();
	this.shape_22.graphics.f(an.fillColor).s().p("ALvPUQjEjhkcovQkRodiujLQjwkYkrAAIpsAAIAAnYIJsAAQH5AAF0GhQCSCjCTD6QBXCVCbEyQDzHeCQCyQB2CSCGBDIigG/QjnhjjCjeg");
	this.shape_22.setTransform(433.075,130.1);

	this.shape_23 = new cjs.Shape();
	this.shape_23.graphics.f(an.fillColor).s().p("AKROtQjEjhkcovQkRodiujLQjwkYkrAAIpsAAIAAnYIJsAAQH5AAF0GhQCSCjCTD6QBXCVCbEyQDzHeCQCyQDGD1DyAVIAAHYQm6gTlLl8g");
	this.shape_23.setTransform(442.5,134);

	this.shape_24 = new cjs.Shape();
	this.shape_24.graphics.f(an.fillColor).s().p("AIHOtQjEjhkcovQkRodiujLQjwkYkrAAIlYAAIAEnYIFUAAQH5AAF1GhQCRCjCTD6QBXCVCbEyQDzHeCQCyQDGD1DyAVIAAHYQm6gTlLl8g");
	this.shape_24.setTransform(456.275,134);

	this.shape_25 = new cjs.Shape();
	this.shape_25.graphics.f(an.fillColor).s().p("AGLOtQjEjhkbovQkSodiujLQjwkYkrAAIhgAAIAUnYIBMAAQH5AAF1GhQCSCjCSD6QBXCVCbEyQDzHeCQCyQDGD1DyAVIAAHYQm6gTlLl8g");
	this.shape_25.setTransform(468.675,134);

	this.shape_26 = new cjs.Shape();
	this.shape_26.graphics.f(an.fillColor).s().p("AEcOgQjEjhkbovQkSodiujLQi8jbjhgwIBznLQFkBNEZE6QCSCjCTD6QBWCVCbEyQDzHeCQCyQDGD1DyAVIAAHYQm6gTlLl8g");
	this.shape_26.setTransform(479.825,135.275);

	this.shape_27 = new cjs.Shape();
	this.shape_27.graphics.f(an.fillColor).s().p("ADDNhQjEjhkcovQkSoditjLQhviBh7hGIEBmRQCoBkCTClQCTCjCTD6QBWCVCbEyQDzHeCQCyQDFD1DzAVIAAHYQm7gTlKl8g");
	this.shape_27.setTransform(488.75,141.625);

	this.shape_28 = new cjs.Shape();
	this.shape_28.graphics.f(an.fillColor).s().p("ABrL6QjDjgkcovQkSodiujLQgdgjgegeIFWlKQAcAdAcAeQCSCkCTD5QBXCVCaEzQDzHdCQCzQDGD1DyAUIAAHZQm6gTlLl9g");
	this.shape_28.setTransform(497.475,151.85);

	this.shape_29 = new cjs.Shape();
	this.shape_29.graphics.f(an.fillColor).s().p("AAbJ5QjDjhkcouQjImNiTjXIGLkNQBEBiBEB0QBXCVCbEyQDyHeCQCyQDGD1DyAVIAAHYQm6gTlLl8g");
	this.shape_29.setTransform(505.475,164.8);

	this.shape_30 = new cjs.Shape();
	this.shape_30.graphics.f(an.fillColor).s().p("Ag5HkQjEjgkcovQhfi7hSiTIGYj6QBOCOB1DnQDyHeCQCyQDGD1DyAUIAAHZQm6gTlKl9g");
	this.shape_30.setTransform(514,179.65);

	this.shape_31 = new cjs.Shape();
	this.shape_31.graphics.f(an.fillColor).s().p("Ah/FRQjEjhkcouIglhJIGojYIAnBNQDyHfCQCyQDGD0DyAVIAAHYQm6gTlKl8g");
	this.shape_31.setTransform(521,194.425);

	this.shape_32 = new cjs.Shape();
	this.shape_32.graphics.f(an.fillColor).s().p("AjNDDQiZiwjQl9IGfjnQCoE6BuCJQDGD0DyAUIAAHZQm6gTlKl9g");
	this.shape_32.setTransform(528.775,208.55);

	this.shape_33 = new cjs.Shape();
	this.shape_33.graphics.f(an.fillColor).s().p("AkkA+QhWhhhlihIGJkIQBHBzA3BFQDGD1DyAVIAAHXQm6gTlKl8g");
	this.shape_33.setTransform(537.5,221.9);

	this.shape_34 = new cjs.Shape();
	this.shape_34.graphics.f(an.fillColor).s().p("AlxgTIFblCQCyDBDWATIAAHXQmjgSlAlXg");
	this.shape_34.setTransform(548.525,233.825);

	this.shape_35 = new cjs.Shape();
	this.shape_35.graphics.f(an.fillColor).s().p("AjYCTIDlmdQBiA1BqAJIAAHXQjngKjKhug");
	this.shape_35.setTransform(563.775,241.3);

	this.shape_36 = new cjs.Shape();
	this.shape_36.graphics.f(an.fillColor).s().p("AgiDpIAhnWQARADATABIAAHXQgjgBgigEg");
	this.shape_36.setTransform(581.975,244.175);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_10}]},18).to({state:[{t:this.shape_11}]},1).to({state:[{t:this.shape_12}]},1).to({state:[{t:this.shape_13}]},1).to({state:[{t:this.shape_14}]},1).to({state:[{t:this.shape_15}]},1).to({state:[{t:this.shape_16}]},1).to({state:[{t:this.shape_17}]},1).to({state:[{t:this.shape_18}]},1).to({state:[{t:this.shape_19}]},1).to({state:[{t:this.shape_20}]},1).to({state:[{t:this.shape_21}]},1).to({state:[{t:this.shape_22}]},1).to({state:[{t:this.shape_23}]},1).to({state:[{t:this.shape_23}]},49).to({state:[{t:this.shape_24}]},1).to({state:[{t:this.shape_25}]},1).to({state:[{t:this.shape_26}]},1).to({state:[{t:this.shape_27}]},1).to({state:[{t:this.shape_28}]},1).to({state:[{t:this.shape_29}]},1).to({state:[{t:this.shape_30}]},1).to({state:[{t:this.shape_31}]},1).to({state:[{t:this.shape_32}]},1).to({state:[{t:this.shape_33}]},1).to({state:[{t:this.shape_34}]},1).to({state:[{t:this.shape_35}]},1).to({state:[{t:this.shape_36}]},1).to({state:[]},1).wait(1));

	// track_b
	this.shape_37 = new cjs.Shape();
	this.shape_37.graphics.f(an.fillColor).s().p("AgiB4IAAjvIBFAAIAADvg");
	this.shape_37.setTransform(154.8,135.5,2,2);

	this.shape_38 = new cjs.Shape();
	this.shape_38.graphics.f(an.fillColor).s().p("AhSDwIAAnfIClAAIAAHfg");
	this.shape_38.setTransform(156.125,135.5);

	this.shape_39 = new cjs.Shape();
	this.shape_39.graphics.f(an.fillColor).s().p("Ah6DwIAAnfID1AAIAAHfg");
	this.shape_39.setTransform(160.125,135.5);

	this.shape_40 = new cjs.Shape();
	this.shape_40.graphics.f(an.fillColor).s().p("Ai9DwIAAnfIF7AAIAAHfg");
	this.shape_40.setTransform(166.775,135.5);

	this.shape_41 = new cjs.Shape();
	this.shape_41.graphics.f(an.fillColor).s().p("AkaDwIAAnfII1AAIAAHfg");
	this.shape_41.setTransform(176.075,135.5);

	this.shape_42 = new cjs.Shape();
	this.shape_42.graphics.f(an.fillColor).s().p("AmSDwIAAnfIMlAAIAAHfg");
	this.shape_42.setTransform(188.05,135.5);

	this.shape_43 = new cjs.Shape();
	this.shape_43.graphics.f(an.fillColor).s().p("AokDwIAAnfIRJAAIAAHfg");
	this.shape_43.setTransform(202.675,135.5);

	this.shape_44 = new cjs.Shape();
	this.shape_44.graphics.f(an.fillColor).s().p("ArRDwIAAnfIWjAAIAAHfg");
	this.shape_44.setTransform(219.975,135.5);

	this.shape_45 = new cjs.Shape();
	this.shape_45.graphics.f(an.fillColor).s().p("AuYDwIAAnfIcxAAIAAHfg");
	this.shape_45.setTransform(239.925,135.5);

	this.shape_46 = new cjs.Shape();
	this.shape_46.graphics.f(an.fillColor).s().p("Ax6DwIAAnfMAj1AAAIAAHfg");
	this.shape_46.setTransform(262.525,135.5);

	this.shape_47 = new cjs.Shape();
	this.shape_47.graphics.f(an.fillColor).s().p("Aq7B4IAAjvIV3AAIAADvg");
	this.shape_47.setTransform(287.8,135.5,2,2);

	this.shape_48 = new cjs.Shape();
	this.shape_48.graphics.f(an.fillColor).s().p("A1sDwIAAnfMArZAAAIAAHfg");
	this.shape_48.setTransform(288.925,135.5);

	this.shape_49 = new cjs.Shape();
	this.shape_49.graphics.f(an.fillColor).s().p("A1KDwIAAnfMAqVAAAIAAHfg");
	this.shape_49.setTransform(292.325,135.5);

	this.shape_50 = new cjs.Shape();
	this.shape_50.graphics.f(an.fillColor).s().p("A0RDwIAAnfMAojAAAIAAHfg");
	this.shape_50.setTransform(297.975,135.5);

	this.shape_51 = new cjs.Shape();
	this.shape_51.graphics.f(an.fillColor).s().p("AzCDwIAAnfMAmFAAAIAAHfg");
	this.shape_51.setTransform(305.875,135.5);

	this.shape_52 = new cjs.Shape();
	this.shape_52.graphics.f(an.fillColor).s().p("AxcDwIAAnfMAi5AAAIAAHfg");
	this.shape_52.setTransform(316.05,135.5);

	this.shape_53 = new cjs.Shape();
	this.shape_53.graphics.f(an.fillColor).s().p("AvgDwIAAnfIfBAAIAAHfg");
	this.shape_53.setTransform(328.475,135.5);

	this.shape_54 = new cjs.Shape();
	this.shape_54.graphics.f(an.fillColor).s().p("AtNDwIAAnfIabAAIAAHfg");
	this.shape_54.setTransform(343.175,135.5);

	this.shape_55 = new cjs.Shape();
	this.shape_55.graphics.f(an.fillColor).s().p("AqkDwIAAnfIVJAAIAAHfg");
	this.shape_55.setTransform(360.125,135.5);

	this.shape_56 = new cjs.Shape();
	this.shape_56.graphics.f(an.fillColor).s().p("AnjDwIAAnfIPHAAIAAHfg");
	this.shape_56.setTransform(379.35,135.5);

	this.shape_57 = new cjs.Shape();
	this.shape_57.graphics.f(an.fillColor).s().p("AkNDwIAAnfIIbAAIAAHfg");
	this.shape_57.setTransform(400.825,135.5);

	this.shape_58 = new cjs.Shape();
	this.shape_58.graphics.f(an.fillColor).s().p("AgPB4IAAjvIAfAAIAADvg");
	this.shape_58.setTransform(424.525,135.5,2,2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_37}]},13).to({state:[{t:this.shape_38}]},1).to({state:[{t:this.shape_39}]},1).to({state:[{t:this.shape_40}]},1).to({state:[{t:this.shape_41}]},1).to({state:[{t:this.shape_42}]},1).to({state:[{t:this.shape_43}]},1).to({state:[{t:this.shape_44}]},1).to({state:[{t:this.shape_45}]},1).to({state:[{t:this.shape_46}]},1).to({state:[{t:this.shape_47}]},1).to({state:[{t:this.shape_47}]},54).to({state:[{t:this.shape_48}]},1).to({state:[{t:this.shape_49}]},1).to({state:[{t:this.shape_50}]},1).to({state:[{t:this.shape_51}]},1).to({state:[{t:this.shape_52}]},1).to({state:[{t:this.shape_53}]},1).to({state:[{t:this.shape_54}]},1).to({state:[{t:this.shape_55}]},1).to({state:[{t:this.shape_56}]},1).to({state:[{t:this.shape_57}]},1).to({state:[{t:this.shape_58}]},1).to({state:[]},1).wait(6));

	// curve_b
	this.shape_59 = new cjs.Shape();
	this.shape_59.graphics.f(an.fillColor).s().p("AhzDzIAAnlIDnAAIgMHlg");
	this.shape_59.setTransform(159.35,24.3);

	this.shape_60 = new cjs.Shape();
	this.shape_60.graphics.f(an.fillColor).s().p("ACMDyIl+AAIAAnlIF+AAQA1ABAyACIgvHjIg4gBg");
	this.shape_60.setTransform(172.125,24.35);

	this.shape_61 = new cjs.Shape();
	this.shape_61.graphics.f(an.fillColor).s().p("AADDqIl+AAIAAnlIF+AAQDOAACrApIicHOQhigSh7AAg");
	this.shape_61.setTransform(185.8,25.225);

	this.shape_62 = new cjs.Shape();
	this.shape_62.graphics.f(an.fillColor).s().p("AiRDIImAAAIAAnlIGAAAQGXAAEMCgIkFGbQiXhWkHAAg");
	this.shape_62.setTransform(200.75,28.6);

	this.shape_63 = new cjs.Shape();
	this.shape_63.graphics.f(an.fillColor).s().p("ADMEDQiah7k8gBIl/AAIAAnlIF/AAQH4AAEiD1QA9A0A9BLIlqFJQgsg9gogfg");
	this.shape_63.setTransform(212.825,35.05);

	this.shape_64 = new cjs.Shape();
	this.shape_64.graphics.f(an.fillColor).s().p("AB4CnQiZh7k9AAIl/AAIAAnlIF/AAQH4AAEiD1QCRB6CREFImhD/QhtjNhYhGg");
	this.shape_64.setTransform(221.175,44.175);

	this.shape_65 = new cjs.Shape();
	this.shape_65.graphics.f(an.fillColor).s().p("AEZF7Qh+j4hihOQiZh6k9AAIl/AAIAAnmIF/AAQH4AAEiD1QCoCNCnFJQArBVAmA/ImiD4QgxhPgxhig");
	this.shape_65.setTransform(227.5,55.6);

	this.shape_66 = new cjs.Shape();
	this.shape_66.graphics.f(an.fillColor).s().p("AH7KUQiIiAiTkiQh+j3hihOQiZh7k9AAIl/AAIAAnmIF/AAQH4AAEiD1QCoCNCnFJQB0DlBPBEIAAAAIk2F1Iglghg");
	this.shape_66.setTransform(233.225,69.3);

	this.shape_67 = new cjs.Shape();
	this.shape_67.graphics.f(an.fillColor).s().p("AL8MGQgygPgwgUQiNg8hthmQiIiAiSkiQh+j3hihOQiah7k8AAImAAAIAAnmIGAAAQH5AAEgD1QCpCNCmFKQB1DkBPBEQAgAcArAVQAlARAqANIAaAGQhYDihUDkIgIgCg");
	this.shape_67.setTransform(242.25,77.6);

	this.shape_68 = new cjs.Shape();
	this.shape_68.graphics.f(an.fillColor).s().p("AOxMfQjRgNilhGQiNg8hthlQiIiAiTkjQh9j2hihPQiah7k9AAIl/AAIAAnmIF/AAQH5AAEhD2QCoCMCnFLQB0DkBPBEQAhAcAqAUQBzA3C2AAIAAHhg");
	this.shape_68.setTransform(251.6281,79.7646,0.9985,0.9987);

	this.shape_69 = new cjs.Shape();
	this.shape_69.graphics.f(an.fillColor).s().p("AOwMdQjRgMilhGQiMg7hthmQiIiAiTkhQh9j4hihNQiZh7k9AAIl/AAIAAnmIF/AAQH4ABEhD0QCoCNCnFJQBzDkBPBEQAhAcArAVQByA3C2AAIAAHfg");
	this.shape_69.setTransform(251.675,79.75);

	this.shape_70 = new cjs.Shape();
	this.shape_70.graphics.f(an.fillColor).s().p("ALzMdQjRgMikhGQiNg7hthmQiHiAiTkhQh+j4hihNQiZh7k9AAIgFAAIANnmQHyADEgDyQCnCNCnFJQBzDkBPBEQAhAcArAVQByA3C2AAIAAHfg");
	this.shape_70.setTransform(270.625,79.75);

	this.shape_71 = new cjs.Shape();
	this.shape_71.graphics.f(an.fillColor).s().p("AJxMSQi8gQiXg/QiNg8hthmQiHiAiTkiQh+j3hihOQhphUizgaIBfndQE1AzDMCsQCnCNCnFKQB0DkBPBEQAhAcAqAVQByA3C3AAIAAHdg");
	this.shape_71.setTransform(280.325,80.825);

	this.shape_72 = new cjs.Shape();
	this.shape_72.graphics.f(an.fillColor).s().p("AIgLvQi8gRiXg/QiNg8hshmQiIiAiTkiQh+j3hihOQg0gphGgbIDAm/QCPA5BvBeQCoCNCmFKQB0DkBPBEQAhAcArAVQBxA3C3AAIAAHeg");
	this.shape_72.setTransform(288.4,84.4);

	this.shape_73 = new cjs.Shape();
	this.shape_73.graphics.f(an.fillColor).s().p("AHdKbQi9gRiXg/QiMg8hthmQiIiAiTkiQh1jmhdhUIFJlmQCfCOCcE4QB0DkBPBEQAhAcArAVQByA3C2AAIAAHeg");
	this.shape_73.setTransform(295.175,92.8);

	this.shape_74 = new cjs.Shape();
	this.shape_74.graphics.f(an.fillColor).s().p("AF3G5Qi9gQiXg/QiMg8hthmQiIiAiTkhIgGgOIG3jRIACAEQBzDlBPBEQAhAcArAVQByA3C2AAIAAHcg");
	this.shape_74.setTransform(305.375,115.325);

	this.shape_75 = new cjs.Shape();
	this.shape_75.graphics.f(an.fillColor).s().p("AE5FbQi8gQiWhAQiNg8hthmQhPhKhTiAIgFgIIGnjxQAxBNApAjQAhAcAqAVQByA3C3AAIAAHdg");
	this.shape_75.setTransform(311.525,124.775);

	this.shape_76 = new cjs.Shape();
	this.shape_76.graphics.f(an.fillColor).s().p("ADZEXQi9gQiWhAQh8g1hjhVIFflTQAUAOAYALQByA3C2AAIAAHdg");
	this.shape_76.setTransform(321.175,131.55);

	this.shape_77 = new cjs.Shape();
	this.shape_77.graphics.f(an.fillColor).s().p("ABND8QiZgNiCgtIDBm9QBdAbB/gBIAAHdg");
	this.shape_77.setTransform(335.125,134.25);

	this.shape_78 = new cjs.Shape();
	this.shape_78.graphics.f(an.fillColor).s().p("AgtDwIAinfQAbACAdAAIAAHdg");
	this.shape_78.setTransform(351.25,135.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_59}]},13).to({state:[{t:this.shape_60}]},1).to({state:[{t:this.shape_61}]},1).to({state:[{t:this.shape_62}]},1).to({state:[{t:this.shape_63}]},1).to({state:[{t:this.shape_64}]},1).to({state:[{t:this.shape_65}]},1).to({state:[{t:this.shape_66}]},1).to({state:[{t:this.shape_67}]},1).to({state:[{t:this.shape_68}]},1).to({state:[{t:this.shape_69}]},55).to({state:[{t:this.shape_70}]},1).to({state:[{t:this.shape_71}]},1).to({state:[{t:this.shape_72}]},1).to({state:[{t:this.shape_73}]},1).to({state:[{t:this.shape_74}]},1).to({state:[{t:this.shape_75}]},1).to({state:[{t:this.shape_76}]},1).to({state:[{t:this.shape_77}]},1).to({state:[{t:this.shape_78}]},1).to({state:[]},1).wait(8));

	// track_a
	this.shape_79 = new cjs.Shape();
	this.shape_79.graphics.f(an.fillColor).s().p("AgsDwIAAnfIBZAAIAAHfg");
	this.shape_79.setTransform(4.525,244);

	this.shape_80 = new cjs.Shape();
	this.shape_80.graphics.f(an.fillColor).s().p("Ag2DwIAAnfIBsAAIAAHfg");
	this.shape_80.setTransform(5.45,244);

	this.shape_81 = new cjs.Shape();
	this.shape_81.graphics.f(an.fillColor).s().p("AhSDwIAAnfIClAAIAAHfg");
	this.shape_81.setTransform(8.275,244);

	this.shape_82 = new cjs.Shape();
	this.shape_82.graphics.f(an.fillColor).s().p("AiBDwIAAnfIEDAAIAAHfg");
	this.shape_82.setTransform(12.95,244);

	this.shape_83 = new cjs.Shape();
	this.shape_83.graphics.f(an.fillColor).s().p("AjCDwIAAnfIGFAAIAAHfg");
	this.shape_83.setTransform(19.5,244);

	this.shape_84 = new cjs.Shape();
	this.shape_84.graphics.f(an.fillColor).s().p("AkWDwIAAnfIItAAIAAHfg");
	this.shape_84.setTransform(27.9,244);

	this.shape_85 = new cjs.Shape();
	this.shape_85.graphics.f(an.fillColor).s().p("Al9DwIAAnfIL7AAIAAHfg");
	this.shape_85.setTransform(38.2,244);

	this.shape_86 = new cjs.Shape();
	this.shape_86.graphics.f(an.fillColor).s().p("An3DwIAAnfIPvAAIAAHfg");
	this.shape_86.setTransform(50.35,244);

	this.shape_87 = new cjs.Shape();
	this.shape_87.graphics.f(an.fillColor).s().p("AqDDwIAAnfIUHAAIAAHfg");
	this.shape_87.setTransform(64.4,244);

	this.shape_88 = new cjs.Shape();
	this.shape_88.graphics.f(an.fillColor).s().p("AsiDwIAAnfIZFAAIAAHfg");
	this.shape_88.setTransform(80.3,244);

	this.shape_89 = new cjs.Shape();
	this.shape_89.graphics.f(an.fillColor).s().p("AvUDwIAAnfIepAAIAAHfg");
	this.shape_89.setTransform(98.075,244);

	this.shape_90 = new cjs.Shape();
	this.shape_90.graphics.f(an.fillColor).s().p("AyYDwIAAnfMAkxAAAIAAHfg");
	this.shape_90.setTransform(117.725,244);

	this.shape_91 = new cjs.Shape();
	this.shape_91.graphics.f(an.fillColor).s().p("A1vDwIAAnfMArfAAAIAAHfg");
	this.shape_91.setTransform(139.225,244);

	this.shape_92 = new cjs.Shape();
	this.shape_92.graphics.f(an.fillColor).s().p("A5ZDwIAAnfMAyzAAAIAAHfg");
	this.shape_92.setTransform(162.625,244);

	this.shape_93 = new cjs.Shape();
	this.shape_93.graphics.f(an.fillColor).s().p("A9WDwIAAnfMA6tAAAIAAHfg");
	this.shape_93.setTransform(187.875,244);

	this.shape_94 = new cjs.Shape();
	this.shape_94.graphics.f(an.fillColor).s().p("EghlADwIAAnfMBDLAAAIAAHfg");
	this.shape_94.setTransform(215,244);

	this.shape_95 = new cjs.Shape();
	this.shape_95.graphics.f(an.fillColor).s().p("AzDB4IAAjvMAmHAAAIAADvg");
	this.shape_95.setTransform(244,244,2,2);

	this.shape_96 = new cjs.Shape();
	this.shape_96.graphics.f(an.fillColor).s().p("Egl+ADwIAAnfMBL8AAAIAAHfg");
	this.shape_96.setTransform(244.95,244);

	this.shape_97 = new cjs.Shape();
	this.shape_97.graphics.f(an.fillColor).s().p("EgliADwIAAnfMBLEAAAIAAHfg");
	this.shape_97.setTransform(247.75,244);

	this.shape_98 = new cjs.Shape();
	this.shape_98.graphics.f(an.fillColor).s().p("EgkyADwIAAnfMBJlAAAIAAHfg");
	this.shape_98.setTransform(252.45,244);

	this.shape_99 = new cjs.Shape();
	this.shape_99.graphics.f(an.fillColor).s().p("EgjxADwIAAnfMBHjAAAIAAHfg");
	this.shape_99.setTransform(259.025,244);

	this.shape_100 = new cjs.Shape();
	this.shape_100.graphics.f(an.fillColor).s().p("EgicADwIAAnfMBE5AAAIAAHfg");
	this.shape_100.setTransform(267.475,244);

	this.shape_101 = new cjs.Shape();
	this.shape_101.graphics.f(an.fillColor).s().p("Egg1ADwIAAnfMBBrAAAIAAHfg");
	this.shape_101.setTransform(277.825,244);

	this.shape_102 = new cjs.Shape();
	this.shape_102.graphics.f(an.fillColor).s().p("A+7DwIAAnfMA93AAAIAAHfg");
	this.shape_102.setTransform(290.025,244);

	this.shape_103 = new cjs.Shape();
	this.shape_103.graphics.f(an.fillColor).s().p("A8uDwIAAnfMA5dAAAIAAHfg");
	this.shape_103.setTransform(304.125,244);

	this.shape_104 = new cjs.Shape();
	this.shape_104.graphics.f(an.fillColor).s().p("A6ODwIAAnfMA0dAAAIAAHfg");
	this.shape_104.setTransform(320.1,244);

	this.shape_105 = new cjs.Shape();
	this.shape_105.graphics.f(an.fillColor).s().p("A3bDwIAAnfMAu3AAAIAAHfg");
	this.shape_105.setTransform(337.95,244);

	this.shape_106 = new cjs.Shape();
	this.shape_106.graphics.f(an.fillColor).s().p("A0WDwIAAnfMAotAAAIAAHfg");
	this.shape_106.setTransform(357.675,244);

	this.shape_107 = new cjs.Shape();
	this.shape_107.graphics.f(an.fillColor).s().p("Aw+DwIAAnfMAh9AAAIAAHfg");
	this.shape_107.setTransform(379.275,244);

	this.shape_108 = new cjs.Shape();
	this.shape_108.graphics.f(an.fillColor).s().p("AtTDwIAAnfIanAAIAAHfg");
	this.shape_108.setTransform(402.775,244);

	this.shape_109 = new cjs.Shape();
	this.shape_109.graphics.f(an.fillColor).s().p("ApWDwIAAnfIStAAIAAHfg");
	this.shape_109.setTransform(428.125,244);

	this.shape_110 = new cjs.Shape();
	this.shape_110.graphics.f(an.fillColor).s().p("AlFDwIAAnfIKLAAIAAHfg");
	this.shape_110.setTransform(455.375,244);

	this.shape_111 = new cjs.Shape();
	this.shape_111.graphics.f(an.fillColor).s().p("AgRB4IAAjvIAjAAIAADvg");
	this.shape_111.setTransform(484.5,244,2,2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_79}]},7).to({state:[{t:this.shape_80}]},1).to({state:[{t:this.shape_81}]},1).to({state:[{t:this.shape_82}]},1).to({state:[{t:this.shape_83}]},1).to({state:[{t:this.shape_84}]},1).to({state:[{t:this.shape_85}]},1).to({state:[{t:this.shape_86}]},1).to({state:[{t:this.shape_87}]},1).to({state:[{t:this.shape_88}]},1).to({state:[{t:this.shape_89}]},1).to({state:[{t:this.shape_90}]},1).to({state:[{t:this.shape_91}]},1).to({state:[{t:this.shape_92}]},1).to({state:[{t:this.shape_93}]},1).to({state:[{t:this.shape_94}]},1).to({state:[{t:this.shape_95}]},1).to({state:[{t:this.shape_95}]},49).to({state:[{t:this.shape_96}]},1).to({state:[{t:this.shape_97}]},1).to({state:[{t:this.shape_98}]},1).to({state:[{t:this.shape_99}]},1).to({state:[{t:this.shape_100}]},1).to({state:[{t:this.shape_101}]},1).to({state:[{t:this.shape_102}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_104}]},1).to({state:[{t:this.shape_105}]},1).to({state:[{t:this.shape_106}]},1).to({state:[{t:this.shape_107}]},1).to({state:[{t:this.shape_108}]},1).to({state:[{t:this.shape_109}]},1).to({state:[{t:this.shape_110}]},1).to({state:[{t:this.shape_111}]},1).to({state:[]},1).wait(6));

	// curve_a
	this.shape_112 = new cjs.Shape();
	this.shape_112.graphics.f(an.fillColor).s().p("AhzDzIAAnlIDnAAIgMHlg");
	this.shape_112.setTransform(11.55,132.6);

	this.shape_113 = new cjs.Shape();
	this.shape_113.graphics.f(an.fillColor).s().p("ACMDyIl+AAIAAnlIF+AAQA1AAAyAEIgvHiIg4gBg");
	this.shape_113.setTransform(24.325,132.65);

	this.shape_114 = new cjs.Shape();
	this.shape_114.graphics.f(an.fillColor).s().p("AADDqIl+AAIAAnlIF+AAQDPAACqApIicHOQhjgSh6AAg");
	this.shape_114.setTransform(38,133.525);

	this.shape_115 = new cjs.Shape();
	this.shape_115.graphics.f(an.fillColor).s().p("AiRDIImAAAIAAnlIGAAAQGXAAEMChIkEGaQiYhWkHAAg");
	this.shape_115.setTransform(52.95,136.9);

	this.shape_116 = new cjs.Shape();
	this.shape_116.graphics.f(an.fillColor).s().p("ADMECQiah7k8AAIl/AAIAAnlIF/AAQH4AAEiD2QA9AzA9BMIlqFHQgsg8goggg");
	this.shape_116.setTransform(65.025,143.35);

	this.shape_117 = new cjs.Shape();
	this.shape_117.graphics.f(an.fillColor).s().p("AB4CnQiZh7k9AAIl/AAIAAnlIF/AAQH4AAEiD1QCRB6CREFImhD/QhtjNhYhGg");
	this.shape_117.setTransform(73.375,152.475);

	this.shape_118 = new cjs.Shape();
	this.shape_118.graphics.f(an.fillColor).s().p("AEZF7Qh+j4hihOQiZh6k9AAIl/AAIAAnmIF/AAQH4AAEiD1QCoCNCnFJQArBVAmA/ImiD4QgxhQgxhhg");
	this.shape_118.setTransform(79.7,163.9);

	this.shape_119 = new cjs.Shape();
	this.shape_119.graphics.f(an.fillColor).s().p("AH7KUQiIiAiTkiQh+j3hihOQiZh7k9AAIl/AAIAAnmIF/AAQH4AAEiD1QCoCNCnFJQB0DlBPBEIAAAAIk2F1Iglghg");
	this.shape_119.setTransform(85.425,177.6);

	this.shape_120 = new cjs.Shape();
	this.shape_120.graphics.f(an.fillColor).s().p("AL8MGQgygQgwgTQiMg8huhmQiHiAiTkiQh/j3hghOQibh7k8AAImAAAIAAnmIGAAAQH4AAEiD1QCnCNCnFKQB1DkBPBEQAhAcAqAVQAkASAsALIAaAHQhZDihUDkIgIgCg");
	this.shape_120.setTransform(94.45,185.9);

	this.shape_121 = new cjs.Shape();
	this.shape_121.graphics.f(an.fillColor).s().p("AOxMfQjRgNilhGQiNg8hthlQiIiAiTkjQh9j2hihPQiah7k9AAIl/AAIAAnmIF/AAQH5AAEhD2QCoCMCnFLQB0DkBPBEQAhAcAqAUQBzA3C2AAIAAHhg");
	this.shape_121.setTransform(104,188.15);

	this.shape_122 = new cjs.Shape();
	this.shape_122.graphics.f(an.fillColor).s().p("AOxMfQjRgNilhFQiNg9hthlQiIiAiTkjQh9j2hihPQiah7k9AAIl/AAIAAnmIF/AAQH5AAEhD2QCoCMCnFLQB0DkBPBEQAhAcArAUQByA3C2AAIAAHhg");
	this.shape_122.setTransform(104,188.15);

	this.shape_123 = new cjs.Shape();
	this.shape_123.graphics.f(an.fillColor).s().p("AM7MfQjRgNilhFQiNg9hthlQiIiAiSkjQh+j2hihPQiah7k9AAIiTAAIAAnmICTAAQH5AAEhD2QCoCMCnFLQB0DkBPBEQAhAcArAUQByA3C2AAIAAHhg");
	this.shape_123.setTransform(115.775,188.15);

	this.shape_124 = new cjs.Shape();
	this.shape_124.graphics.f(an.fillColor).s().p("AK3MdQjRgNilhFQiNg8hthmQiHiAiTkiQh+j3hihOQh8hjjmgTIAAnoQGmAaEADYQCnCNCnFKQB0DkBPBEQAhAcAqAVQByA3C3AAIAAHgg");
	this.shape_124.setTransform(129.025,188.325);

	this.shape_125 = new cjs.Shape();
	this.shape_125.graphics.f(an.fillColor).s().p("AJcMGQjRgMilhGQiNg8hshmQiIiAiTkiQh+j3hihOQhFg4hngeIBtnaQDiA8ChCIQCoCNCmFKQB0DkBPBEQAhAcAqAVQByA3C3AAIAAHgg");
	this.shape_125.setTransform(138.125,190.6);

	this.shape_126 = new cjs.Shape();
	this.shape_126.graphics.f(an.fillColor).s().p("AIVLKQjRgNilhFQiNg8hshmQiIiAiTkiQh+j3hihOQgOgMgQgKID7miQA3AjAwApQCoCNCmFKQB0DkBPBEQAhAcArAVQByA3C2AAIAAHgg");
	this.shape_126.setTransform(145.175,196.625);

	this.shape_127 = new cjs.Shape();
	this.shape_127.graphics.f(an.fillColor).s().p("AHhJqQjRgMilhGQiMg8hthmQiIiAiTkhQhRifhFhZIFqlGQBwCHBuDcQB0DlBPBDQAhAcAqAVQByA3C3AAIAAHgg");
	this.shape_127.setTransform(150.425,206.2);

	this.shape_128 = new cjs.Shape();
	this.shape_128.graphics.f(an.fillColor).s().p("AGuHvQjSgNilhFQiLg9huhlQiHiAiTkiIgkhDIgLgVIGojuQAdAzAcA5QB0DlBPBEQAhAcAqAUQByA2C2AAIAAHhg");
	this.shape_128.setTransform(155.55,218.55);

	this.shape_129 = new cjs.Shape();
	this.shape_129.graphics.f(an.fillColor).s().p("AF1F5QjSgNikhFQiMg8huhmQhohjhwjBIG2jZQBGB7A3AvQAhAcAqAVQByA3C2AAIAAHfg");
	this.shape_129.setTransform(161.25,230.325);

	this.shape_130 = new cjs.Shape();
	this.shape_130.graphics.f(an.fillColor).s().p("AEjEsQjRgMikhGQiNg8hthmQgbgZgageIF+ksIARAQQAhAcArAVQByA3C2AAIAAHfg");
	this.shape_130.setTransform(169.4,237.975);

	this.shape_131 = new cjs.Shape();
	this.shape_131.graphics.f(an.fillColor).s().p("ACcECQjQgMilhGIghgPID7miQBnAkCTAAIAAHfg");
	this.shape_131.setTransform(182.925,242.2);

	this.shape_132 = new cjs.Shape();
	this.shape_132.graphics.f(an.fillColor).s().p("AgJDzQgmgCglgEIA4nfQA0AGA9AAIAAHfg");
	this.shape_132.setTransform(199.475,243.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_112}]},7).to({state:[{t:this.shape_113}]},1).to({state:[{t:this.shape_114}]},1).to({state:[{t:this.shape_115}]},1).to({state:[{t:this.shape_116}]},1).to({state:[{t:this.shape_117}]},1).to({state:[{t:this.shape_118}]},1).to({state:[{t:this.shape_119}]},1).to({state:[{t:this.shape_120}]},1).to({state:[{t:this.shape_121}]},1).to({state:[{t:this.shape_122}]},56).to({state:[{t:this.shape_123}]},1).to({state:[{t:this.shape_124}]},1).to({state:[{t:this.shape_125}]},1).to({state:[{t:this.shape_126}]},1).to({state:[{t:this.shape_127}]},1).to({state:[{t:this.shape_128}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_130}]},1).to({state:[{t:this.shape_131}]},1).to({state:[{t:this.shape_132}]},1).to({state:[]},1).wait(12));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,585.5,268);
// library properties:
lib.properties = {
	id: 'D3BF8FFD1A924633B375DE9F0FCF18B6',
	width: 586,
	height: 268,
	fps: 24,
	color: "#FFF000",
	opacity: 0.00,
	manifest: [],
	preloads: []
};

// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }
p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['D3BF8FFD1A924633B375DE9F0FCF18B6'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}

an.setAnimationEndHandler = function(handler) {
	an.endHandler = handler
}

an.setHeader = function(isHeader) {
	an.header = isHeader
}

an.setFillColor = function(color) {
	an.fillColor = color
}

an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers, stage) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = window.innerWidth, ih=window.innerHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}

export {AdobeAn, lib}
